import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DialogContent, DialogActions } from '@mui/material';
import { useProfile } from '@app/api/profile/useProfile';
import { ThemeButton } from '@shared/ui/buttons';
import { PasswordInput } from '@shared/ui/forms/inputs';
import Note from '@shared/ui/messages/Note';
import { passwordMatchRule, validateServerErrors } from '@utils/validation';

export default function ChangePasswordDialog({ close }) {
  const { t } = useTranslation();
  const { changePassword } = useProfile();
  const {
    control,
    setError,
    trigger,
    getValues,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      password: '',
      password_confirmation: '',
      old_password: '',
    },
  });

  async function onSubmit(data) {
    try {
      const res = await changePassword(data);
      if (res) close();
    } catch (error) {
      validateServerErrors(setError, error);
    }
  }

  return (
    <>
      <DialogContent>
        <div className="form">
          <PasswordInput
            label={t('current_password')}
            placeholder={t('enter_password')}
            control={control}
            name="old_password"
            error={errors.old_password}
            noValidation
          />
          <Note
            html
            type="warning"
            title={t('password_requirements')}
            content={t('password_rule')}
          />
          <PasswordInput
            label={t('new_password')}
            placeholder={t('enter_password')}
            control={control}
            name="password"
            error={errors.password}
            onValueChange={() => {
              if (getValues('password_confirmation')) {
                trigger('password_confirmation');
              }
            }}
          />
          <PasswordInput
            label={t('repeat_new_password')}
            placeholder={t('enter_password')}
            control={control}
            name="password_confirmation"
            error={errors.password_confirmation}
            validation={(value) =>
              passwordMatchRule(value, getValues('password'))
            }
          />
        </div>
      </DialogContent>
      <DialogActions>
        <ThemeButton
          onClick={handleSubmit(onSubmit)}
          startIcon="check"
          loading={isSubmitting}
        >
          {t('confirm')}
        </ThemeButton>
      </DialogActions>
    </>
  );
}
